import React from 'react'
import {BrowserRouter, Route, Switch, Redirect, withRouter } from 'react-router-dom'
import StickerPage from './pages/sticker-page/stickerPage'
import AppraisalPage from './pages/appraisal-page/appraisalPage'
import ContactPage from './pages/contact-page/contactPage'
import './styles/index.scss'

export default function Apps(){
  return(
    <BrowserRouter>
      {
        /* For testing replace `document-viewer.autoipacket.com` with `localhost` */
        window.location.hostname === 'document-viewer.autoipacket.com' && window.location.pathname === '/' && (
          window.location.href = "https://ipacket.us"
        )
      }
      <Route
        path="/sticker/:id"
        component={(props)=>{
          return(
            <StickerPage id={props.match.params.id} />
          )
        }}
      />
      <Route
        path="/appraisal/:id"
        component={(props)=>{
          return(
            <AppraisalPage id={props.match.params.id} />
          )
        }}
      />
      <Route
        path="/contact/:id"
        component={(props)=>{
          return(
            <ContactPage id={props.match.params.id} />
          )
        }}
      />

    </BrowserRouter>
  )
}
